import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        backgroundColor: "white",
        padding: "15px 10px 10px 10px"
    },
}));